export default function Close({ animate }: { animate: boolean }) {
    return (
        <div
            className={`relative group w-10 h-10 flex justify-center items-center gap-[4px] rotate-45 hover:scale-110 hover:rotate-[57deg] duration-200 ${
                animate ? 'animate-closeRotate' : ''
            } p-2`}
        >
            <div
                className={`absolute w-[3px] h-6 bg-white group-hover:bg-red-600 rounded-full duration-200 ${
                    animate ? 'animate-closeHeight' : ''
                }`}
            ></div>
            <div
                className={`absolute w-6 h-[3px] bg-white group-hover:bg-red-600 rounded-full duration-200 ${
                    animate ? 'animate-closeWidth' : ''
                }`}
            ></div>
        </div>
    )
}
